import { render } from "./SentGeo.vue?vue&type=template&id=2c8aa0f4&ts=true"
import script from "./SentGeo.vue?vue&type=script&lang=ts"
export * from "./SentGeo.vue?vue&type=script&lang=ts"

import "./SentGeo.vue?vue&type=style&index=0&id=2c8aa0f4&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__